<template>
  <div class="flex flex-col w-full">
    <div class="mt-3">
      <div
        class="text-lg text-center text-secondary"
      >
        {{ $t('message.settings.accountsTab.connectAccountModal.selectAccountType') }}
      </div>
      <div class="flex flex-col items-center justify-center gap-4 mt-3 mb-4 md:flex-row md:space-x-6">
        <button
          @click="selectOption('business')"
          class="inline-block w-full px-10 py-2 text-sm leading-5 text-center text-white rounded md:w-auto bg-sc-blue md:px-14"
        >
          {{ $t('message.settings.accountsTab.connectAccountModal.accountType.business') }}
        </button>
        <button
          @click="selectOption('individual')"
          class="inline-block w-full px-10 py-2 text-sm leading-5 text-center text-white rounded md:w-auto bg-sc-blue md:px-14"
        >
          {{ $t('message.settings.accountsTab.connectAccountModal.accountType.individual') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import UsersApi from '../../api/users';

export default {
  props: {
    entityId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      widget: null,
      holderType: null,
    };
  },
  mounted() {
    const scriptEl = document.createElement('script');
    scriptEl.setAttribute('src', 'https://js.fintoc.com/v1/');
    document.head.appendChild(scriptEl);
  },
  methods: {
    selectOption(option) {
      this.holderType = option;
      this.buildWidget();
      this.$emit('onOptionSelect', 'option');
      this.openWidget();
    },
    buildWidget() {
      this.widget = Fintoc.create({
        holderType: this.holderType,
        product: 'movements',
        publicKey: import.meta.env.VITE_FINTOC_PUBLIC_KEY,
        webhookUrl: this.webhookUrl,
        onExit: this.destroyWidget,
        onSuccess: this.successfulConnection,
      });
    },
    openWidget() {
      this.widget.open();
    },
    destroyWidget() {
      this.widget.destroy();
      this.isHidden = true;
    },
    successfulConnection() {
      this.$emit('onSuccess', true);
      UsersApi.updateUser(this.$store.state.users.currentUser.id, { event: 'move_to_third_step' });
    },
  },
  computed: {
    webhookUrl() {
      return `https://${document.location.host}/entities/${this.entityId}/links`;
    },
  },
};
</script>
